import { render, staticRenderFns } from "./DThresholdColorSetting.vue?vue&type=template&id=45920bd9&scoped=true"
import script from "./DThresholdColorSetting.vue?vue&type=script&lang=js"
export * from "./DThresholdColorSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45920bd9",
  null
  
)

export default component.exports